/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 19:47:46
 * @Description: 投稿管理路由
 */
'use strict';
angular.module("settingsRouterModule",[]).
config(['$stateProvider', function($stateProvider){
    $stateProvider.state("index.settings", {
        url: "/settings",
        views: {
            "main@index": {
                template: "<div ui-view='main'>test</div>",
                controller: "settingsCtrl"
            }
        }
    }).state("index.settings.modifydata", {
        url: "/modifydata",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/modifyData/modifyData_tpl.html",
                controller: "modifyDataCtrl"
            }
        }
    }).state("index.settings.pgcmodifydata", {
        url: "/pgcmodifydata",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/modifyData/pgcModifyData_tpl.html",
                controller: "pgcModifyDataCtrl"
            }
        }
    }).state("index.settings.passwordsetting", {
        url: "/passwordsetting",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/passwordSetting/passwordSetting_tpl.html",
                controller: "passwordSettingCtrl"
            }
        }
    }).state("index.settings.settlementmanagement", {
        url: "/settlementmanagement",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/settlementManagement/settlementManagement_tpl.html",
                controller: "settlementManagementCtrl"
            }
        }
    }).state("index.settings.message", {
        url: "/message",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/message/message_tpl.html",
                controller: "messageCtrl"
            }
        }
    }).state("index.settings.contractChannel", {
        url: "/contractChannel",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/contractChannel/contractChannel_tpl.html",
                controller: "contractChannelCtrl"
            }
        }
    }).state("index.settings.mainOperationInfo", {
        url: "/mainOperationInfo",
        views: {
            "main@index.settings": {
                templateUrl: "./main/settings/mainOperationInfo/mainOperationInfo_tpl.html",
                controller: "mainOperationInfoCtrl"
            }
        }
    });

}]);
